// En tms-filters-date.js
import React, {useState} from "react";
import { TMSSearchDate } from "./tms-filters-search-date";

export const TMSFiltersDate = ({isBlankActive, onDateChange}) => {
    const [inputValue, setInputValue] = useState(isBlankActive);
  return <TMSSearchDate isBlankActive={isBlankActive} onDateChange={onDateChange}/>;
};
